export let Arg = {
	queryParams: {
		area: [],
		applyYear: "2023",
		level: "3",
		province: "辽宁省",
		city: "鞍山市",
		county: "",
	}	
}
